export const noop = () => {};

export const sanitizeImageUrl = (url = '') => url.replace(/<SIZE>/g, '400');

export const pipe = (...funcs) => (arg) => funcs.reduce((acc, cur) => cur(acc), arg);

export const sortItemToTopOfList = (list, itemToMove) => (
  list
    .slice()
    .sort((first, second) => {
      if (first === itemToMove) return -1;
      if (second === itemToMove) return 1;
      return 0;
    })
);

export const getProductImage = (productData) => productData.media?.image?.url || '';
